import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { ProductiveHeading05 } from 'ozone/atoms';
const Container = styled.div`
  background-color: var(--coolest-gray-10);
  padding: var(--spacing-05) var(--spacing-06);
  border-bottom: none;
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: ${(props)=>props.subTitlePlacement === 'top' ? 'column-reverse' : 'column'};
  gap: var(--spacing-02);
`;
const Title = styled.h5`
  ${ProductiveHeading05};
  margin-bottom: 0;
`;
const SubTitle = styled.div`
  ${BodyShort01};
  color: ${(props)=>props.subTitleColor};
`;
export const Header = ({ title, subTitle, subTitleColor, subTitlePlacement, headerStyle })=>/*#__PURE__*/ _jsxs(Container, {
        subTitlePlacement: subTitlePlacement,
        style: headerStyle,
        children: [
            title ? /*#__PURE__*/ _jsx(Title, {
                "data-cy": "add.conditions.drawer.title",
                children: title
            }) : null,
            subTitle ? /*#__PURE__*/ _jsx(SubTitle, {
                subTitleColor: subTitleColor,
                children: subTitle
            }) : null
        ]
    });
